var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.676 90 c -0.355 0 -0.711 -0.07 -1.05 -0.21 c -0.677 -0.28 -1.204 -0.808 -1.484 -1.485 c -0.285 -0.687 -0.894 -0.762 -1.142 -0.762 s -0.857 0.074 -1.143 0.764 c -0.579 1.395 -2.185 2.06 -3.58 1.484 l -3.373 -1.397 c -1.394 -0.575 -2.061 -2.182 -1.485 -3.579 c 0.287 -0.691 -0.091 -1.175 -0.267 -1.351 c -0.175 -0.176 -0.659 -0.554 -1.349 -0.269 c -0.674 0.281 -1.417 0.28 -2.096 0.001 c -0.677 -0.28 -1.205 -0.808 -1.485 -1.485 l -1.396 -3.369 c -0.28 -0.678 -0.28 -1.423 0 -2.099 c 0.281 -0.678 0.808 -1.205 1.486 -1.484 c 0.687 -0.284 0.762 -0.894 0.762 -1.142 c 0 -0.249 -0.075 -0.858 -0.764 -1.144 c -1.398 -0.58 -2.062 -2.187 -1.484 -3.583 l 1.396 -3.37 c 0.579 -1.396 2.187 -2.059 3.58 -1.484 c 0.691 0.285 1.174 -0.092 1.35 -0.267 c 0.176 -0.176 0.554 -0.659 0.269 -1.349 c -0.578 -1.395 0.086 -3.001 1.48 -3.581 l 3.375 -1.396 c 0.672 -0.281 1.418 -0.279 2.095 -0.002 c 0.677 0.28 1.205 0.807 1.486 1.483 c 0.286 0.691 0.895 0.766 1.143 0.766 c 0.249 0 0.858 -0.074 1.144 -0.765 c 0.279 -0.676 0.807 -1.203 1.484 -1.483 c 0.675 -0.28 1.421 -0.278 2.1 0.002 l 3.369 1.395 c 0.676 0.279 1.203 0.807 1.483 1.484 c 0.28 0.677 0.279 1.423 -0.002 2.1 c -0.284 0.687 0.094 1.17 0.27 1.346 c 0.175 0.175 0.654 0.555 1.348 0.268 c 0.679 -0.281 1.422 -0.279 2.099 0 c 0.677 0.28 1.204 0.808 1.484 1.485 l 1.395 3.369 c 0.577 1.395 -0.088 3.001 -1.48 3.581 c -0.692 0.286 -0.767 0.896 -0.767 1.145 c 0 0.248 0.074 0.857 0.764 1.143 c 0.001 0 0.002 0.001 0.003 0.001 c 1.395 0.58 2.058 2.187 1.479 3.582 l -1.396 3.37 c -0.279 0.675 -0.806 1.202 -1.482 1.482 c -0.677 0.28 -1.422 0.281 -2.097 0.002 c -0.689 -0.285 -1.175 0.091 -1.351 0.267 c -0.176 0.176 -0.554 0.659 -0.269 1.348 c 0.28 0.677 0.281 1.422 0 2.1 c -0.28 0.677 -0.807 1.203 -1.484 1.483 l -3.369 1.395 C 49.386 89.93 49.03 90 48.676 90 z M 49.837 86.773 c 0 0.001 0.001 0.002 0.001 0.003 C 49.838 86.775 49.837 86.774 49.837 86.773 z M 50.882 86.341 c 0.001 0.001 0.001 0.002 0.001 0.003 C 50.883 86.343 50.883 86.342 50.882 86.341 z M 45 83.544 c 1.695 0 3.246 0.807 4.216 2.128 l 1.326 -0.549 c -0.248 -1.622 0.278 -3.289 1.477 -4.486 c 1.198 -1.197 2.863 -1.723 4.486 -1.477 l 0.549 -1.326 c -1.321 -0.972 -2.127 -2.522 -2.127 -4.216 c 0 -1.695 0.807 -3.246 2.128 -4.217 l -0.549 -1.326 c -1.62 0.249 -3.287 -0.277 -4.486 -1.476 c -1.198 -1.198 -1.725 -2.865 -1.478 -4.487 l -1.325 -0.549 c -0.972 1.321 -2.522 2.128 -4.217 2.128 s -3.245 -0.807 -4.216 -2.128 l -1.326 0.549 c 0.248 1.622 -0.279 3.289 -1.477 4.487 c -1.198 1.198 -2.868 1.724 -4.486 1.476 L 32.945 69.4 c 1.321 0.972 2.128 2.522 2.128 4.218 c 0 1.694 -0.807 3.245 -2.128 4.216 l 0.549 1.326 c 1.623 -0.25 3.289 0.279 4.487 1.477 c 1.198 1.198 1.724 2.864 1.476 4.486 l 1.326 0.549 C 41.754 84.35 43.305 83.544 45 83.544 z M 38.433 84.698 l 0.002 0.001 C 38.435 84.699 38.434 84.698 38.433 84.698 z M 32.276 79.5 c -0.002 0.001 -0.003 0.001 -0.005 0.002 C 32.272 79.501 32.274 79.501 32.276 79.5 z M 31.844 78.455 c -0.001 0 -0.002 0.001 -0.004 0.001 C 31.842 78.456 31.843 78.455 31.844 78.455 z M 58.154 78.454 c 0.001 0 0.002 0.001 0.002 0.001 S 58.155 78.454 58.154 78.454 z M 48.193 61.139 c 0.002 0.001 0.003 0.001 0.004 0.002 L 48.193 61.139 z M 41.809 61.138 l -0.004 0.002 C 41.807 61.139 41.808 61.138 41.809 61.138 z M 50.884 60.89 c -0.001 0.002 -0.002 0.004 -0.002 0.006 C 50.882 60.894 50.883 60.892 50.884 60.89 z M 39.116 60.889 c 0 0.001 0 0.002 0.001 0.003 C 39.117 60.891 39.116 60.89 39.116 60.889 z M 49.84 60.456 c -0.001 0.001 -0.001 0.002 -0.001 0.003 C 49.839 60.458 49.839 60.457 49.84 60.456 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 80.504 c -3.797 0 -6.886 -3.09 -6.886 -6.887 c 0 -3.797 3.089 -6.886 6.886 -6.886 s 6.887 3.089 6.887 6.886 C 51.887 77.414 48.797 80.504 45 80.504 z M 45 70.731 c -1.591 0 -2.886 1.295 -2.886 2.886 c 0 1.592 1.295 2.887 2.886 2.887 c 1.592 0 2.887 -1.295 2.887 -2.887 C 47.887 72.026 46.592 70.731 45 70.731 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 39.707 c -9.551 0 -17.321 -7.77 -17.321 -17.321 v -5.064 C 27.679 7.771 35.449 0 45 0 s 17.321 7.77 17.321 17.321 v 5.064 C 62.321 31.937 54.551 39.707 45 39.707 z M 45 4 c -7.345 0 -13.321 5.976 -13.321 13.321 v 5.064 c 0 7.345 5.976 13.321 13.321 13.321 c 7.346 0 13.321 -5.976 13.321 -13.321 v -5.064 C 58.321 9.976 52.346 4 45 4 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.767 75.659 l -9.838 -0.001 c -1.104 0 -2 -0.895 -2 -2 c 0 -1.104 0.895 -2 2 -2 l 0 0 l 9.838 0.001 c 0.258 0 0.468 -0.209 0.468 -0.467 v -9.25 c 0 -12.261 -9.974 -22.235 -22.235 -22.235 c -12.26 0 -22.235 9.975 -22.235 22.235 v 9.248 c 0 0.258 0.209 0.467 0.467 0.467 h 9.839 c 1.104 0 2 0.896 2 2 c 0 1.104 -0.895 2 -2 2 h -9.839 c -2.463 0 -4.467 -2.004 -4.467 -4.467 v -9.248 c 0 -14.466 11.769 -26.235 26.235 -26.235 s 26.235 11.769 26.235 26.235 v 9.25 C 71.235 73.655 69.231 75.659 66.767 75.659 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.81d92c56df6dd2b16b725db4c36bf2e8.svg";
export { ForwardRef as ReactComponent };